import Vue from 'vue';
import newsTransformer from './../../transformers/news';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(newsTransformer.fetch(errors));
};

export default news => (
  new Promise((resolve, reject) => {
    Vue.$http.post('news/test', news)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/test.js